import { render, staticRenderFns } from "./OrderListItem.vue?vue&type=template&id=6c645c1a&scoped=true"
import script from "./OrderListItem.vue?vue&type=script&lang=js"
export * from "./OrderListItem.vue?vue&type=script&lang=js"
import style0 from "./OrderListItem.vue?vue&type=style&index=0&id=6c645c1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c645c1a",
  null
  
)

export default component.exports